import React from "react";
import { CheckCircle, Clock, Package, Wrench, CalendarCheck, ClipboardText } from "@phosphor-icons/react";

import { Card } from "@/components/ui/card";
import {
  INSTALLATION_STATUS,
  normalizeInstallationStatus,
} from "@/lib/gmaoInstallationStatus";

// Les étapes correspondent aux statuts métier, sans regrouper
// "prête à installer", "planifiée" et "en cours".
const STEPS = Object.freeze([
  { key: INSTALLATION_STATUS.PENDING, label: "À préparer", detail: "Informations de livraison", icon: Package },
  { key: INSTALLATION_STATUS.READY_FOR_DELIVERY, label: "Attente confirmation", detail: "Bon de livraison partagé", icon: Clock },
  { key: INSTALLATION_STATUS.READY_FOR_INSTALLATION, label: "Prête à installer", detail: "Livraison acceptée", icon: ClipboardText },
  { key: INSTALLATION_STATUS.SCHEDULED, label: "Planifiée", detail: "Intervention organisée", icon: CalendarCheck },
  { key: INSTALLATION_STATUS.IN_PROGRESS, label: "En cours", detail: "Intervention terrain", icon: Wrench },
  { key: INSTALLATION_STATUS.INSTALLED, label: "Terminée", detail: "Machine installée", icon: CheckCircle },
]);

export default function InstallationStatusCards({ status }) {
  const normalized = normalizeInstallationStatus(status);
  const active = normalized === INSTALLATION_STATUS.ARCHIVED
    ? null
    : normalized;

  return (
    <section className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-testid="installation-detail-status-cards" aria-label="Étapes de l'installation">
      {STEPS.map((step, index) => {
        const Icon = step.icon;
        const selected = active === step.key;
        return (
          <Card
            key={step.key}
            variant="acta"
            aria-current={selected ? "step" : undefined}
            className={selected ? "p-4 border-[var(--do-accent)] bg-[var(--do-accent-soft)]" : "p-4"}
          >
            <div className="flex items-center gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[var(--do-border)] bg-[var(--do-bg-2)] text-sm font-bold text-[var(--do-ink)]">
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <div className="font-heading font-bold text-[var(--do-text)]">{step.label}</div>
                <div className="mt-1 text-xs text-[var(--do-muted)]">{step.detail}</div>
              </div>
              <Icon size={20} className={selected ? "text-[var(--do-accent)]" : "text-[var(--do-muted)]"} />
            </div>
          </Card>
        );
      })}
    </section>
  );
}
